<template>
  <div class="artwork-detail-box">
    <!-- 艺术品详情 -->
    <div class="the-body-box">
      <el-breadcrumb separator=">" class="breadcrumb-box">
        <el-breadcrumb-item to="/">{{
          $t("IndexNavbar.HomePage")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="`/artist-detail?artistId=${artDetail.artistId}`"
          >{{ artDetail.chArtistName }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ artDetail.chArtworkName }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="artwork-main-box clearfix">
        <div class="f-l main-img-box">
          <!-- <h5 v-if="item.status!=5">{{item.status === 6 ? '已售出': item.status === 7 ? '已下架' : ''}}</h5> -->
          <img :src="artDetail.artworkLogoPath" alt="" />
        </div>
        <div class="f-r main-msg-box">
          <div class="name mar-top">《{{ artDetail.chArtworkName }}》</div>
          <div class="mar-top">
            <span class="common-tags" v-if="artDetail.excellent">{{
              $t("LastTranslate.ScreenTitle1")
            }}</span>
          </div>
          <div class="msg-box common-flex-box">
            <img class="head-img" :src="artDetail.picPath" />
            <div class="text-box">
              <div class="text-gray author">{{ artDetail.chArtistName }}</div>
              <div>
                <span class="text-gray"
                  >{{ $t("ArtworkDetail.how") }} {{ artDetail.artworkCount }}
                  {{ $t("ArtworkDetail.artworks") }}</span
                >
                |
                <!-- <span class="text-gray">{{$t('ArtworkDetail.viewArt')}}{{artDetail.artworkCount}}{{$t('ArtworkDetail.Pieces')}}{{$t('IndexNavbar.Artwork')}}</span> | -->
                <router-link
                  class="text-tone"
                  :to="`/artist-detail?artistId=${artDetail.artistId}`"
                >
                  {{ $t("ArtworkDetail.viewArt") }}
                </router-link>
              </div>
            </div>
          </div>
          <div>
            《{{ artDetail.chArtworkName }}》 {{ artDetail.finishTime }}
          </div>
          <div class="artwork-msg">
            {{ artDetail.chKindName }}
            {{ artDetail.width ? artDetail.width + "cm" : "" }}
            {{ artDetail.width && artDetail.height ? "X" : "" }}
            {{ artDetail.height ? artDetail.height + "cm" : "" }}
          </div>
          <div class="main-price">
            <strong>{{ $t("PriceUnit") }} {{ artDetail.price | fnKeep }}</strong>
          </div>
          <div class="ps-text text-light-gray">
            <!-- {{ $t("ArtworkDetail.PriceTips") }} -->
          </div>
          <el-popover
            class="btn-lg-tone"
            placement="bottom"
            width="160"
            popper-class="top-ewm-popover"
            trigger="click"
          >
            <img src="../../../../assets/img/KingsArts-ewm.png" />
            <span slot="reference" class="app-download">
              <span class="iconfont iconphone_icon"></span>
              {{ $t("ArtworkDetail.download") }}
            </span>
          </el-popover>
        </div>
      </div>
      <div class="artwork-description-box">
        <el-row>
          <el-col :span="24" class="text-center">
            <div class="description-text text-left">
              <div class="desc-item">
                {{ $t("LastTranslate.AttributeName") }}：{{
                  artDetail.chArtworkName
                }}
              </div>
              <div class="desc-item">
                {{ $t("LastTranslate.AttributeAtr") }}：{{
                  artDetail.chArtistName
                }}
              </div>
              <div class="desc-item">
                {{ $t("LastTranslate.AttributeMaterial") }}：{{
                  artDetail.chTexture
                }}
              </div>
              <div class="desc-item">
                {{ $t("LastTranslate.AttributeDate") }}：{{
                  artDetail.finishTime
                }}
              </div>
              <div class="desc-item">
                {{ $t("LastTranslate.AttributeSize") }}：{{
                  artDetail.width ? artDetail.width + "cm" : ""
                }}
                {{ artDetail.width && artDetail.height ? "X" : "" }}
                {{ artDetail.height ? artDetail.height + "cm" : "" }}
              </div>
              <div
                class="desc-item"
                v-for="(item, i) in artDetail.arrList"
                :key="i"
              >
                {{ item.key }}：{{ item.value }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="common-description-box" v-if="workList.comment">
        <div class="title text-center">
          {{ $t("LastTranslate.ExpertsEvaluation") }}
        </div>
        <div class="content-box">
          <img
            src="../../../../assets/img/left-top.png"
            alt=""
            class="tip-img left-img"
          />
          <img
            src="../../../../assets/img/right-bottom.png"
            alt=""
            class="tip-img right-img"
          />
          <div class="texts">{{ workList.comment }}</div>
        </div>
      </div>
      <div class="img-txt-detail-box">
        <div class="common-title text-center">
          {{ $t("ArtworkDetail.Details") }}
        </div>
        <div class="detail-list">
          <div class="detail-item clearfix">
            <div class="img-box f-l">
              <!-- <el-image
              style="width: 100%; height: initial"
              :src="workList.logoPath"
              fit="contain"></el-image> -->
              <img :src="workList.logoPath" alt="" />
            </div>
            <div class="text-box f-r">
              <div class="txt" v-html="workList.chDescribe"></div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="common-title text-center">
          {{ $t("IndexNavbar.RecommendArtwork") }}
        </div>
        <div class="common-workslist-box">
          <el-row :gutter="24">
            <el-col
              :span="6"
              v-for="(item, i) in workList.artworkList"
              :key="i"
            >
              <div class="works-card">
                <router-link
                  :to="`/artwork-detail?artworkId=${item.artworkId}`"
                >
                  <div class="img-box">
                    <div
                      style="width: 100%; height: 100%"
                      class="bg-img-center"
                      :style="{
                        'background-image': 'url(' + item.artworkPath + ')',
                      }"
                    ></div>
                  </div>

                  <div class="text-box">
                    <div class="text text-gray ellipsis">
                      {{ item.chArtworkName }}
                    </div>
                    <div class="text text-gray ellipsis">
                      {{ item.chArtistName }}
                    </div>
                    <div class="clearfix">
                      <strong class="f-l text-line"
                        >{{ $t("PriceUnit") }} {{ item.price | fnKeep }}</strong
                      >
                      <span class="f-r common-tags" v-if="item.excellent">{{
                        $t("LastTranslate.ScreenTitle1")
                      }}</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  data() {
    return {
      artDetail: [],
      workList: {
        logoPath: "",
        artworkList: [],
      },
      artworkId: null,
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  watch: {
    $route(to) {
      this.artworkId = to.query.artworkId;
      this.artwork();
      this.worksDetails();
    },
  },
  methods: {
    // 艺术品信息
    artwork() {
      let artworkId = this.$route.query.artworkId;
      this.$commonPromise("get", this.$Api.artwork, { artworkId }).then(
        (res) => {
          if (res.code === 200) {
            let arrList = [];
            res.data.artworkPropertyDTOList.forEach((item) => {
              let arr = [];
              console.log(item);
              if (item.artworkPropertyValueDTOList) {
                item.artworkPropertyValueDTOList.forEach((val) => {
                  arr.push(val.chName);
                });
              } else if (item.type == 3 && item.chPropertyName) {
                arr.push(item.chPropertyName);
              }
              arrList.push({
                key: item.chName,
                value: arr.join(","),
              });
            });
            res.data.arrList = arrList;
            this.artDetail = res.data;
          }
        }
      );
    },
    // 艺术品图文详情、评价
    worksDetails() {
      let artworkId = this.$route.query.artworkId;
      this.$commonPromise("get", this.$Api.worksDetails, { artworkId }).then(
        (res) => {
          if (res.code === 200) {
            this.workList = res.data;
          }
        }
      );
    },
  },
  mounted() {
    this.artwork();
    this.worksDetails();
  },
};
</script>
<style lang="scss" scoped>
.artwork-detail-box {
  .the-body-box {
    padding: 64PX 0;
  }
  .artwork-main-box {
    margin: 20PX 0 60PX;
    .main-img-box {
      position: relative;
      height: 500PX;
      width: 500PX;
      border: 1PX solid #e6e6e6;
      h5 {
        width: 100PX;
        height: 100PX;
        border-radius: 50%;
        text-align: center;
        line-height: 100PX;
        color: #fff;
        font-size: 14PX;
        transform: rotate(45deg);
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.12), 0 0 6PX rgba(0, 0, 0, 0.04);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
      }
    }
    .main-msg-box {
      width: 660PX;
      .name {
        font-size: 24PX;
        font-weight: bold;
      }
      .mar-top {
        margin-top: 16PX;
      }
      .msg-box {
        padding: 10PX;
        margin: 30PX 0;
        background-color: #f7f7f7;
        .head-img {
          width: 50PX;
          height: 50PX;
          margin-right: 20PX;
          border-radius: 100%;
        }
        .text-box {
          flex: 1;
          .author {
            margin-bottom: 15PX;
            font-size: 16PX;
          }
        }
      }
      .artwork-msg {
        margin: 20PX 0 60PX;
      }
      .main-price {
        font-size: 36PX;
      }
      .ps-text {
        margin: 20PX 0 45PX;
      }
      .btn-lg-tone {
        width: 240PX;
        height: 54PX;
        line-height: 52PX;
        font-size: 18PX;
        color: #fff;
        cursor: pointer;
        outline: none;
        font-weight: bold;
        border-color: transparent;
        background-color: $main-color;
        display: inline-block;
        text-align: center;
      }
    }
  }
  .artwork-description-box {
    margin-bottom: 60PX;
    background-color: #f7f7f7;
    .description-text {
      display: flex;
      flex-wrap: wrap;
      zoom: 1;
      font-size: 16PX;
      .desc-item {
        width: 33.33%;
        padding: 32PX 40PX;
      }
    }
  }
  .common-title {
    margin-bottom: 60PX;
    font-size: 22PX;
    font-weight: bold;
  }
  .img-txt-detail-box {
    margin: 60PX 0;
    padding: 0 85PX;
    .detail-item {
      margin-bottom: 60PX;
      .img-box {
        width: 300PX;
        height: 300PX;
        position: relative;
        img {
          max-width: 300PX;
          max-height: 300PX;
          margin: auto;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .text-box {
        position: relative;
        width: 690PX;
        // height: 300PX;
        .txt {
          // position: absolute;
          // top: 50%;
          // left: 0;
          // transform: translateY(-50%);
          min-height: 300PX;
          line-height: 2;
          overflow: hidden;
        }
      }
    }
  }
}
</style>